import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

function getSessionId() {
  let id = sessionStorage.getItem("vufc_session_id");
  if (!id) {
    id = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem("vufc_session_id", id);
  }
  return id;
}

function isMobile() {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent || "");
}

/**
 * Fires a pageview on every route change.
 * Skips the admin dashboard — only tracks the public site.
 */
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    const payload = {
      path: location.pathname,
      session_id: getSessionId(),
      is_mobile: isMobile(),
      referer: document.referrer || "",
    };
    api.post("/analytics/track", payload).catch(() => {
      // Silent — analytics must never disturb the user
    });
  }, [location.pathname]);

  return null;
}
